import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Button from '../../../../shared/_TBComponents/Button';
import Text from '../../../../shared/_TBComponents/Text';
import Title from '../../../../shared/_TBComponents/Title';

const ModalWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  min-width: 100%;
`;

const Header = styled('div')`
  width: 100%;
  margin-bottom: 24px;
  position: relative;
`;

const MessageWrapper = styled('div')`
  padding: 0 20px;
`;

const Message = styled(Text)`
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
`;

const ButtonWrapper = styled('div')`
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-top: 60px;
  width: 100%;
`;

const FolderAccessConfirmation = ({
  onApplyToAll,
  onCancel,
  newGroups,
  newUsers,
  isRemovalChange,
  willBecomeGlobal,
}) => {
  const getChangeSummary = () => {
    const changes = [];
    if (newGroups.length > 0) {
      changes.push(`${newGroups.length} group${newGroups.length > 1 ? 's' : ''}`);
    }
    if (newUsers.length > 0) {
      changes.push(`${newUsers.length} user${newUsers.length > 1 ? 's' : ''}`);
    }
    if (changes.length === 2) {
      return `${changes[0]} and ${changes[1]}`;
    }

    return changes.join(' and ');
  };

  return (
    <ModalWrapper>
      <Header>
        <Title icon='folder'>
          Update Document Access
        </Title>
      </Header>
      <MessageWrapper>
        <Message>
          {willBecomeGlobal ? (
            <>
              You&apos;ve removed all permissions from this folder.
              <br />
              <br />
              If you choose &apos;Keep Current Permissions&apos;, only this folder&apos;s permissions
              will be updated and the documents inside will keep their existing access.
              <br />
              <br />
              If you choose &apos;Apply to All Documents&apos;, this folder and all of its
              documents will become globally accessible.
            </>
          ) : (
            <>
              You&apos;ve
              {' '}
              {isRemovalChange ? 'removed' : 'added'}
              {' '}
              {getChangeSummary()}
              {' '}
              {isRemovalChange ? 'from' : 'to'}
              {' '}
              this folder.
              <br />
              <br />
              {isRemovalChange
                ? 'Would you like to remove their access to all documents within this folder or update specific permissions later?'
                : 'Would you like to grant them access to all documents within this folder or update specific permissions later?'}
              {isRemovalChange && (
              <>
                <br />
                <br />
                If any documents in this folder currently have exactly these permissions and no others,
                they will be moved to the Main Directory if you choose &apos;Apply to All Documents&apos;.
              </>
              )}
            </>
          )}
        </Message>
      </MessageWrapper>
      <ButtonWrapper>
        <Button
          name='Keep Current Permissions'
          onClick={onCancel}
          bgColor='#999'
          txtColor='white'
          square
          large
          noBorder
          styledWrapperProps={{ width: '100%' }}
        />
        <Button
          name='Apply to All Documents'
          onClick={onApplyToAll}
          bgColor='#10cd8c'
          txtColor='white'
          square
          large
          noBorder
          styledWrapperProps={{ width: '100%' }}
        />
      </ButtonWrapper>
    </ModalWrapper>
  );
};

FolderAccessConfirmation.propTypes = {
  onApplyToAll: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  newGroups: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  })),
  newUsers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    first: PropTypes.string,
    last: PropTypes.string,
  })),
  isRemovalChange: PropTypes.bool,
  willBecomeGlobal: PropTypes.bool,
};

FolderAccessConfirmation.defaultProps = {
  newGroups: [],
  newUsers: [],
  isRemovalChange: false,
  willBecomeGlobal: false,
};

export default FolderAccessConfirmation;
